import { LitElement, html } from 'lit';
import '../../../shared/components/input/Input';
import '../../../shared/components/form-group/FormGroup';
import '../../../shared/components/dropdown/Dropdown';
import '../../../shared/components/icons/IconCheckboxUnChecked';
import '../../../shared/components/icons/IconCheckboxChecked';
import '../../../shared/components/icons/IconCircleX';
import '../../../shared/components/icons/IconOption';
import { updateUrlParams } from '../../../shared/utils/helpers';
import styles from './styles';

class JobBoardFilter extends LitElement {
  static styles = styles;

  static properties = {
    filterOptions: {
      type: Object,
      state: true,
    },
    filterValue: {
      type: Object,
      state: true,
    },
    mobile: { type: Boolean },
    filterHidden: {
      type: Boolean,
      state: true,
    },
    numOfFiltersApplied: {
      type: Number,
      state: true,
    },
  };

  constructor() {
    super();
    this.filterOptions = {};
    this.filterValue = {};
    this.mobile = false;
    this.filterHidden = false;
    this.numOfFiltersApplied = 0;
  }

  #showFilter() {
    this.filterHidden = false;
  }

  #setUrlFilterParams(key) {
    const searchParams = new URLSearchParams(window.location.search);

    if (this.filterValue[key].length > 0) {
      searchParams.set(key, this.filterValue[key].join(','));
    } else {
      searchParams.delete(key);
    }

    updateUrlParams(searchParams);
  }

  async #setFilterCount() {
    this.numOfFiltersApplied = Object.keys(this.filterValue).reduce(
      (accumulator, option) => accumulator + this.filterValue[option].length,
      0,
    );

    await this.requestUpdate();
  }

  #toggleCheck(option, checked) {
    const splitIndex = option.indexOf('-');
    const filterName = option.substring(0, splitIndex);
    const filterBy = option.substring(splitIndex + 1);

    const indexOfFilterBy = this.filterValue[filterName].indexOf(filterBy);
    if (checked && indexOfFilterBy <= -1) {
      this.filterValue[filterName].push(filterBy);
    }

    if (!checked && indexOfFilterBy > -1) {
      this.filterValue[filterName].splice(indexOfFilterBy, 1);
    }

    this.#setUrlFilterParams(filterName);
    this.#setFilterCount();

    this.dispatchEvent(
      new CustomEvent('filter-event', {
        composed: true,
        bubbles: true,
        detail: {
          filter: {
            name: filterName,
            value: filterBy,
          },
        },
      }),
    );
  }

  #addEventListeners() {
    document.addEventListener('click', (event) => {
      const filterContainer = this.renderRoot.querySelector('.job-filter-container');
      let contains = false;

      event.composedPath().forEach((item) => {
        if (item instanceof Element && filterContainer?.contains(item)) {
          contains = true;
        }
      });

      if (!contains && this.mobile && this.numOfFiltersApplied > 0) {
        this.filterHidden = true;
      }
    });
  }

  #clearFilter(option) {
    this.filterValue[option] = [];
    this.#setUrlFilterParams(option);
    this.#setFilterCount();

    this.dispatchEvent(
      new CustomEvent('filter-event', {
        composed: true,
        bubbles: true,
        detail: {
          filter: {
            name: option,
          },
        },
      }),
    );
  }

  #clearFilterAll() {
    Object.keys(this.filterOptions).forEach((option) => {
      this.#clearFilter(option);
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.#addEventListeners();
  }

  render() {
    return html`
      <div class="job-filter-container">
        ${this.mobile && this.filterHidden ? html`
          <div class="filter-toggle" @click=${() => this.#showFilter()}>
            <tenable-icon-option width="24px" height="24px"></tenable-icon-option>
            <span>${this.numOfFiltersApplied} Filter(s) Applied</span>
          </div>
        ` : html`
          <div class="job-filter-option-container">
            ${Object.keys(this.filterOptions).map((option) => html`
              <tenable-dropdown
                class="job-filter-dropdown ${option}"
                label="${`${option.charAt(0).toUpperCase()}${option.slice(1)}${this.filterValue[option].length > 0 ? ` (${this.filterValue[option].length})` : ''}`}"
                >
                <tenable-form-group>
                  ${Object.keys(this.filterOptions[option]).length > 0 ? html`
                    ${Object.keys(this.filterOptions[option]).sort().map((item) => html`
                      <div class="hover">
                        <div class="job-filter-item">
                          ${this.filterValue[option].includes(item) ? html`
                            <tenable-icon-checkbox-checked
                              class="job-filter-checkbox"
                              @click=${() => this.#toggleCheck(`${option}-${item}`, false)}
                              data-testid="${`${option}-${item}`}"
                            >
                            </tenable-icon-checkbox-checked>` : html`
                            <tenable-icon-checkbox-unchecked
                              class="job-filter-checkbox"
                              @click=${() => this.#toggleCheck(`${option}-${item}`, true)}
                              data-testid="${`${option}-${item}`}"
                            >
                            </tenable-icon-checkbox-unchecked>`}
                          <div class="label">${`${item} (${this.filterOptions[option][item]})`}</div>
                        </div>
                      </div>`)}
                    ` : html`
                      <div class="job-filter-item">No Filters Available<div>
                    `}
                    ${this.filterValue[option].length > 0 ? html`
                    <div class="job-filter-item clear" @click=${() => this.#clearFilter(option)}>
                      <tenable-icon-circle-x class="x-icon"></tenable-icon-circle-x>
                      <span>Clear Filter</span>
                    </div>` : html``}
                <tenable-form-group>
              </tenable-dropdown>
            `)}
            ${Object.keys(this.filterOptions).length > 0 ? html`
              <div class="clear-all-button" @click=${() => this.#clearFilterAll()}>
                <tenable-icon-circle-x class="x-icon"></tenable-icon-circle-x>
                <span>Clear All<span>
              <div>
            ` : html``}
          </div>
        `}
      </div>`;
  }
}

customElements.define('tenable-job-board-filter', JobBoardFilter);
